import logo from "./logo.svg";
import "./App.css";
import Navbar from "./components/scripts/Navbar";
import UserHome from "./pages/UserHome";
import SupervisorHome from "./pages/SupervisorHome";
import AdminHome from "./pages/AdminHome";
import GenericHome from "./pages/GenericHome";
import Login from "./pages/Login";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Verification from "./pages/Verification";
import VerificationCR from "./pages/VerificationCR";
import RuleEnrollment from "./pages/RuleEnrollment";
import CallHistory from "./pages/CallHistory";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RuleCheckPoint from "./pages/RuleCheckPoint";
import ManagerHome from "./pages/ManagerHome";
import PdfViewer from "./pages/PdfViewer";
import UploadPdf from "./pages/UploadPdf";
import TaskFeeder from "./pages/TaskFeeder";
import FeederView from "./pages/FeederView";
import UploadFaxFile from "./pages/UploadFaxFile";
import ControlPanel from "./pages/ControlPanel";
import ClinicalReview from "./pages/ClinicalReview";
import ClinicalHome from "./pages/ClinicalHome";
import ClinicalAudit from "./pages/ClinicalAudit";
import Report from "./pages/Report";
import AuditHome from "./pages/AuditHome";
import TaskFeedAudit from "./pages/TaskFeedAudit";
import UploadPage from "./pages/UploadPage";
import OverallClinical from "./pages/OverallClinical";
import UserManagement from "./pages/UserManagement";
import ClinicalReviewAudit from "./components/scripts/ClinicalReviewAudit";
import UserContext from "./components/Common/UserContext";
import AccessDenied from "./pages/AccessDenied";
import Navbar2 from "./components/scripts/Navbar2";
import { useContext, useEffect, useState } from "react";
import { UserContextProvider } from "./components/Common/UserContext";
import menus from "./user-config.json";
import TokenFetchingPage from "./nervehub/TokenFetchingPage";
import NerveHub from "./nervehub/NerveHub";
import RSATokenGenerator from "./nervehub/RSATokenGenerator";
import ChangePassword from "./pages/ChangePassword";
import SkillManagement from "./pages/SkillManagement";
import SkillMapping from "./pages/SkillMapping";
import Presenter from "./pages/Presenter";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import info from "./info.json";

toast.configure();
let userafterLogin = "";

//Function to Check if user is accessing its allowed user if not denying its access==============================================================================================
const ProtectedRoute = ({
  setAccessdenied,
  component: Component,
  allowedRoles,
  ...rest
}) => {
  const { userRole: user, isPresenter } = useContext(UserContext);
  return (
    <Route
      {...rest}
      render={(props) => {
        if (allowedRoles.includes(user)) {
          return (
            <>
              <Component {...props} />
            </>
          );
        } else {
          setAccessdenied(true);
          sessionStorage.setItem("accessDenied", true);
          console.log(sessionStorage.getItem("accessDenied"));
          return <Redirect to="/AccessDenied" />;
        }
      }}
    />
  );
};

function App() {
  //States==============================================================================================

  const [accessDenied, setAccessdenied] = useState(
    JSON.parse(sessionStorage.getItem("accessDenied"))
  );
  console.log("s==========>", sessionStorage.getItem("accessDenied"));

  //Access denied state intitally=false, if the user access link not in its allowed url's set it to true
  const { accessToken } = useContext(UserContext);
  // console.log("user context acces token from App", accessToken);
  const history = useHistory();
  const instance = info.INSTACE;
  const [loginUrl, setLoginUrl] = useState(() =>
    instance == "DEMO" ? "/Login" : "/"
  );

  const {
    userRole: user,
    setUserRole: setUser,
    passChangeRequired,
  } = useContext(UserContext); // Accessing user details
  const [isPassChangeRequired, setIsPassChangeRequired] =
    useState(passChangeRequired);

  console.log(typeof accessDenied);
  console.log(
    `accessDenied=>${accessDenied} 
    ,user=>${user},
    !accessDenied=>${!accessDenied},
    passChangeRequired == undefined || passChangeRequired == false=>${
      passChangeRequired == undefined || passChangeRequired == false
    },
    !passChangeRequired=>${!passChangeRequired}`
  );

  const different_routes = [
    //Storing all the Routes in an Array
    "/UserHome",
    "/Verification",
    "/RuleEnrollment",
    "/RuleCheckPoint",
    "/Dashboard",
    "/PdfViewer",
    "/UploadPdf",
    "/TaskFeeder",
    "/FeederView",
    "/UploadFaxFile",
    "/ControlPanel",
    "/VerificationCR",
    "/ClinicalReview",
    "/ClinicalHome",
    "/ClinicalAudit",
    "/AuditHome",
    "/Report",
    "/UploadPage",
    "/TaskFeedAudit",
    "/OverallClinical",
    "/UserManagement",
    "/ClinicalReviewAudit",
    "/SkillManagement",
    "/SkillMapping",
    "/Presenter",
  ];

  //Function for Finding the Allowed Users for a particular Route from menus.json{}==============================================================================================
  const rolesWithTargetRoute = (targetRoute) =>
    Object.entries(menus)
      .filter(([role, items]) => {
        return items["menus"].some((item) => item.route === targetRoute);
      })
      .map(([role]) => role);

  //Function to finding allowed users and the corresponding Route==============================================================================================
  const routesAndAllowedUsers = different_routes.map((item) => {
    const roles = rolesWithTargetRoute(item);
    const allowedRoles = roles.map((role) => {
      return role
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    });
    return { item, allowedRoles };
  });

  //For Particular Route find the allowed Users and if there exists no such Route in menus.json{} passing the default array of users==============================================================================================
  const rolesForParticularRoute = (route, defult) => {
    const foundObject = routesAndAllowedUsers.find((obj) => obj.item === route);
    return foundObject &&
      foundObject.allowedRoles &&
      foundObject.allowedRoles.length > 0
      ? foundObject.allowedRoles
      : defult;
  };

  //UI==============================================================================================
  return (
    <Router>
      <Switch>
        <div>
          <Route path="/TokenFetching" exact component={TokenFetchingPage} />
          {instance == "DEMO" && <Route path="/" exact component={NerveHub} />}

          <Route path={loginUrl} exact component={Login} />
          {instance !== "DEMO" && (
            <Route path="/Login">
              <Redirect to="/" />
            </Route>
          )}

          {/*=========================================Conditionally Rendering navbar and if the Access is denied not showing Navbar===================================================== */}
          {window.location.pathname !== "/PdfViewer" &&
          window.location.pathname !== "/ChangePassword" &&
          user &&
          !accessDenied &&
          (passChangeRequired == undefined || passChangeRequired == false) &&
          !passChangeRequired ? (
            <Navbar2 />
          ) : null}
          {/*=========================================Routing different routes with the allowed users array===================================================== */}
          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/UserHome"
            component={UserHome}
            allowedRoles={rolesForParticularRoute("/UserHome", [
              "Intake User",
              "Supervisor",
            ])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/Presenter"
            component={Presenter}
            allowedRoles={rolesForParticularRoute("/Presenter", [
              "Intake User",
              "Supervisor",
            ])}
          />
          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/SkillManagement"
            component={SkillManagement}
            allowedRoles={rolesForParticularRoute("/SkillManagement", [""])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/SkillMapping"
            component={SkillMapping}
            allowedRoles={rolesForParticularRoute("/SkillMapping", [
              "Supervisor",
            ])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/Verification"
            component={Verification}
            allowedRoles={rolesForParticularRoute("/Verification", [
              "Intake User",
              "Supervisor",
            ])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/RuleCheckPoint"
            component={RuleCheckPoint}
            allowedRoles={rolesForParticularRoute("/RuleCheckPoint", ["Admin"])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/Dashboard"
            component={ManagerHome}
            allowedRoles={rolesForParticularRoute("/Dashboard", [
              "Intake User",
              "Nurse",
              "Supervisor",
              "Auditor",
              "Admin",
            ])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/PdfViewer"
            component={PdfViewer}
            allowedRoles={rolesForParticularRoute("/PdfViewer", [
              "Intake User",
              "Nurse",
              "Supervisor",
              "Auditor",
              "Admin",
            ])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/UploadPdf"
            component={UploadPdf}
            allowedRoles={rolesForParticularRoute("/UploadPdf", ["Admin"])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/TaskFeeder"
            component={TaskFeeder}
            allowedRoles={rolesForParticularRoute("/TaskFeeder", [
              "Admin",
              "Supervisor",
            ])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/FeederView"
            component={FeederView}
            allowedRoles={rolesForParticularRoute("/FeederView", ["Admin"])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/UploadFaxFile"
            component={UploadFaxFile}
            allowedRoles={rolesForParticularRoute("/UploadFaxFile", ["Admin"])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/ControlPanel"
            component={ControlPanel}
            allowedRoles={rolesForParticularRoute("/ControlPanel", ["Admin"])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/VerificationCR"
            component={VerificationCR}
            allowedRoles={rolesForParticularRoute("/VerificationCR", [
              "Intake User",
              "Nurse",
              "Supervisor",
            ])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/ClinicalReview"
            component={ClinicalReview}
            allowedRoles={rolesForParticularRoute("/ClinicalReview", [
              "Nurse",
              "Supervisor",
            ])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/ClinicalHome"
            component={ClinicalHome}
            allowedRoles={rolesForParticularRoute("/ClinicalHome", [
              "Nurse",
              "Supervisor",
            ])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/ClinicalAudit"
            component={ClinicalAudit}
            allowedRoles={rolesForParticularRoute("/ClinicalAudit", [
              "Auditor",
              "Supervisor",
            ])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/AuditHome"
            component={AuditHome}
            allowedRoles={rolesForParticularRoute("/AuditHome", [
              "Auditor",
              "Supervisor",
            ])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/Report"
            component={Report}
            allowedRoles={rolesForParticularRoute("/Report", [
              "Auditor",
              "Supervisor",
            ])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/UploadPage"
            component={UploadPage}
            allowedRoles={rolesForParticularRoute("/UploadPage", ["Admin"])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/TaskFeedAudit"
            component={TaskFeedAudit}
            allowedRoles={rolesForParticularRoute("/TaskFeedAudit", [
              "Admin",
              "Auditor",
              "Supervisor",
            ])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/OverallClinical"
            component={OverallClinical}
            allowedRoles={rolesForParticularRoute("/OverallClinical", [
              "Nurse",
            ])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/ClinicalReviewAudit"
            component={ClinicalReviewAudit}
            allowedRoles={rolesForParticularRoute("/ClinicalReviewAudit", [
              "Auditor",
              "Nurse",
              "Supervisor",
            ])}
          />
          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/UserManagement"
            component={UserManagement}
            allowedRoles={rolesForParticularRoute("/UserManagement", ["Admin"])}
          />

          <ProtectedRoute
            setAccessdenied={setAccessdenied}
            path="/RuleEnrollment"
            component={RuleEnrollment}
            allowedRoles={rolesForParticularRoute("/RuleEnrollment", ["Admin"])}
          />

          <Route path="/AccessDenied" exact component={AccessDenied} />
          <Route path="/ChangePassword" exact component={ChangePassword} />
        </div>
      </Switch>
    </Router>
  );
}
export default App;
